import { PartnerOnboardingStatus, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button, TableFiltersContainer } from 'UI';
import { OnboardingFilterValues } from '../types';
import useOnboardingFiltersFormConfig from './useOnboardingFiltersFormConfig';
import styles from './OnboardingFilters.module.scss';

const cn = withStyles(styles);

export type OnboardingFiltersProps = {
  /**
   * The applied filters. Seeded by the page from `?stage=&accountType=` (Accounts and Partners page
   * tiles), so the form must show them on first render; it also changes when a summary pill is clicked.
   */
  values: OnboardingFilterValues;
  /** Status dropdown options in display order (pipeline stages first); render labels via `usePartnerAccountStatusLabel`. */
  statuses: PartnerOnboardingStatus[];
  /** Search was clicked; the page applies the values, returns to page 1 and refetches. */
  onSubmit: (values: OnboardingFilterValues) => void;
};

export default function OnboardingFilters({ values, statuses, onSubmit }: OnboardingFiltersProps) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { ctx, renderFormElements } = useOnboardingFiltersFormConfig({ initialValues: values, statuses, onSubmit });

  return (
    // Open by default (Confluence §6.3); the dot on the trigger follows the applied filters, not the draft.
    <TableFiltersContainer
      filtersApplied={values.entityTypes.length > 0 || values.status !== '' || values.keyword !== ''}
    >
      <TableFiltersContainer.Trigger />

      <TableFiltersContainer.Content>
        {/* A real <form>, so Enter in the keyword field searches. */}
        <form className={cn('form')} onSubmit={ctx.handleSubmit}>
          <div className={cn('filters')}>{renderFormElements()}</div>

          <Button id="onboardingTracker-search" type="submit" size="small" colorScheme="primary">
            {tGlobal('Buttons.search')}
          </Button>
        </form>
      </TableFiltersContainer.Content>
    </TableFiltersContainer>
  );
}
